import { gql } from "@apollo/client";

export const GET_MANUFACTURE = gql`
  query GetManufacturer($email: String!) {
    getManufacturer(email: $email) {
       id
       email
       firstName
       lastName
       type
       manufacturerObject {
         brand
         businessForm
         isBusinessInfo
         isStripeConnected
         stripeConnectUrl
         isShopifyConnected
       }
    }
  }
`;
export const GET_MANUFACTURE_BY_ID = gql`
  query GetManufacturerById($id: ID!) {
    getManufacturerById(id: $id) {
       brand
       businessForm
       email
       id
       firstName
       lastName
       type
       manufacturerObject {
         brand
         businessForm
         isBusinessInfo
         isStripeConnected
         stripeConnectUrl
         isShopifyConnected
       }
    }
  }
`;
